import React, { useEffect, useState } from 'react'
import { GlobalDataState } from '../../Context'
import FilterFavourites from './FilterFavourites';
import { Link } from 'react-router-dom';
const Favorites = () => {
    const {
        state:{stack},
        dispatch,
    }=GlobalDataState();
    
    const {sorted,setClickedId}=GlobalDataState();

    // useEffect(()=>{
    
    // },[])
      // console.log(stack)
    // const {
    //   // product:{products},
    //    productState:{sort}
    // }  =GlobalDataState();  
    
//    const transformProduct=()=>{
//     let sortedProducts=stack;
//     if(sort){
//         sortedProducts=sortedProducts.sort((a,b)=>sort==="lowtoHigh"?a.vote_average-b.vote_average:b.vote_average-a.vote_average)
//     }
//     return sortedProducts;
//    }
//    console.log(transformProduct);

  
  //console.log(sorted)
//    const [sortedData,setSortedData]=useState([]);
//    setSortedData(sorted)

   if(sorted===null){
    return (
        <div> 
            <FilterFavourites/>
            <div style={{margin:"7rem"}}>
                {  
                 Object.values(stack).map((idx)=>(
                <Link to={"/moviesdetails"} style={{textDecoration:'none',color:'inherit'}}>
                <div onClick={()=>setClickedId(idx.id)}>
                <div style={{display:'flex',borderRadius:'1rem',boxShadow:"0 0 0 2px gray",width:"75%",marginBottom:'2rem'}}>
                    <div>
                    <img style={{width:'10rem',borderTopLeftRadius:'1rem',borderBottomLeftRadius:'1rem',height:'14rem',display:'block'}} src={`https://image.tmdb.org/t/p/w500/${idx.poster_path}`}></img>
                    </div>
                    <div style={{marginLeft:'2rem'}}>
                        <div style={{fontSize:"1.5rem",fontWeight:'bolder',marginTop:'1rem'}}>{idx.title}</div>
                        <div style={{display:'flex' ,gap:'2rem'}}>
                        <div>{idx.vote_average}</div>
                        <div>{idx.release_date}</div>
                        </div>
                        <div style={{marginTop:'2rem'}}><p>{idx.overview}</p></div>
                    </div>
                </div>
                </div>
                </Link>
            ))
            }
            </div>
        </div>
          )
        }else{
            return (
                <div> 
                    <FilterFavourites/>
                    <div style={{margin:"7rem"}}>
                        {  
                         Object.values(sorted).map((idx)=>(
                        <Link to={"/moviesdetails"} style={{textDecoration:'none',color:'inherit'}}>
                        <div onClick={()=>setClickedId(idx.id)}>
                        <div style={{display:'flex',borderRadius:'1rem',boxShadow:"0 0 0 2px gray",width:"75%",marginBottom:'2rem'}}>
                            <div>
                            <img style={{width:'10rem',borderTopLeftRadius:'1rem',borderBottomLeftRadius:'1rem',height:'14rem',display:'block'}} src={`https://image.tmdb.org/t/p/w500/${idx.poster_path}`}></img>
                            </div>
                            <div style={{marginLeft:'2rem'}}>
                                <div style={{fontSize:"1.5rem",fontWeight:'bolder',marginTop:'1rem'}}>{idx.title}</div>
                                <div style={{display:'flex' ,gap:'2rem'}}>
                                <div>{idx.vote_average}</div>
                                <div>{idx.release_date}</div>
                                </div>
                                <div style={{marginTop:'2rem'}}><p>{idx.overview}</p></div>
                            </div>
                        </div>
                        </div>
                        </Link>
                    ))
                    }
                    </div>
                </div>
                  )
        }
}

export default Favorites